import { render, staticRenderFns } from "./Lunbotuliebiao.vue?vue&type=template&id=1b7f4dcd&scoped=true&"
import script from "./Lunbotuliebiao.vue?vue&type=script&lang=js&"
export * from "./Lunbotuliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Lunbotuliebiao.vue?vue&type=style&index=0&id=1b7f4dcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f4dcd",
  null
  
)

export default component.exports